import React from "react";
import { ContinueButton, ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { TrailerCloseoutModal } from "./TrailerCloseoutModal";

export interface TrailerCloseoutErrorModalProps {
  title: string;
  text: string;
  hideModalValue: TrailerCloseoutModal;
}

export const TrailerCloseoutErrorModal: React.FC<TrailerCloseoutErrorModalProps> = ({
  title,
  text,
  hideModalValue,
}) => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.trailerCloseout.errorModalTitle" defaultMessage={title} />}
      text={<FormattedMessage id="sortation.trailerCloseout.errorModalText" defaultMessage={text} />}
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <ContinueButton block onClick={() => hideModal(hideModalValue)} />
    </ModalTemplate>
  );
};
